import React, { useContext, useEffect, useState } from 'react';
import {
  FaPhone, FaEnvelope, FaInstagram, FaTwitter
} from 'react-icons/fa';

import '../../../assets/css/Buyer/agents/agents.css';
import AgentsDetails from 'subscreens/Buyer/agents/AgentsDetails';
import MyNavbar from 'components/Buyer/navbar/MyNavbar';
import Footer from 'components/Buyer/footer/Footer';
import Pagination from 'subscreens/Buyer/agents/Pagination';
import HeroSection from 'subscreens/general/pageheros/HeroSection';
import AppContext from 'context/AppContext';
import axios from 'axios';


export default function Agents() {
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [agents, setAgents] = useState([]);
  const [totalsellers, setTotalSellers] = useState("");
  const [pendingSellers, setPendingSellers] = useState("");
  const [verifiedSellers, setVerifiedSellers] = useState("");
  const [blockedSellers, setBlockedSellers] = useState("");
  const { baseUrl, baseUrlForFiles,authToken } = useContext(AppContext);

  const getAllSellers = () => {

    axios.get(`${baseUrl}/buyer/sellers/viewAllBuyerSellers`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        if (response.data.success == true) {
          console.log("Agent Details:", response.data);
          setAgents(response.data.sellers);
          setTotalSellers(response.data.sellers?.length);
          setPendingSellers(response.data.totalpending);
          setVerifiedSellers(response.data.totalverified);
          setBlockedSellers(response.data.totalblocked);
        }
      }).catch((error) => {
        console.log(error);
      })
  };
  useEffect(() => {
    getAllSellers();
  }, []);

  // 👇 changed from 8 to 4
  const itemsPerPage = 4;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentAgents = agents.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(agents.length / itemsPerPage);

  const handleAgentClick = (agent) => {
    setSelectedAgent(agent);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBack = () => {
    setSelectedAgent(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // If agent is selected, show AgentDetails component
  if (selectedAgent) {
    return <AgentsDetails agent={selectedAgent} onBack={handleBack} />;
  }

  // Main Agents Grid View
  return (
    <>
      <MyNavbar />

      <div className="agents-page agents-animate-fade-in agents-pb-20">
        {/* Hero Section */}
        <HeroSection
          title="Meet Our Agents"
          subtitle="Expert professionals at your service"
          // label="Professional Team"
          image="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920"
        />
        {/* <div className="agents-hero-content">
            <span className="agents-hero-badge">Professional Team</span>
            <h1 className="agents-hero-title">
              Meet Our Real Estate <br />Agents
            </h1>
            <p className="agents-hero-description">
              Our team of experienced real estate professionals is dedicated to helping you find your perfect home with personalized service and expert guidance.
            </p>
          </div> */}


        <div className="agents-container-custom">
          <div className="agents-section-header">
            <h2 className="agents-section-title">Experts Agents</h2>
            <div className="agents-section-divider"></div>
            <p className="agents-section-description">
              Browse through our list of top-rated agents who are ready to assist you with your property needs.
            </p>
          </div>

          {/* Agents Grid */}
          <div className="agents-grid">
            {currentAgents.map((agent) => (
              <div
                key={agent.id}
                onClick={() => handleAgentClick(agent)}
                className="agents-card"
              >
                <div className="agents-card-image-wrapper">
                  <img
                    src={`${baseUrlForFiles}${agent?.profileImage}`}
                    alt={agent?.firstName}
                    className="agents-card-image"
                  />
                  <div className="agents-card-overlay">
                    <span className="agents-card-overlay-text">View Profile</span>
                  </div>
                </div>
                <div className="agents-card-content">
                  <h3 className="agents-card-name">{agent?.firstName} {agent?.lastName}</h3>
                  <p className="agents-card-role">{agent.role}</p>

                  {/* <div className="agents-card-social">
                    <button className="agents-social-btn" onClick={(e) => e.stopPropagation()}>
                      <FaPhone size={12} />
                    </button>
                    <button className="agents-social-btn" onClick={(e) => e.stopPropagation()}>
                      <FaEnvelope size={12} />
                    </button>
                    <button className="agents-social-btn" onClick={(e) => e.stopPropagation()}>
                      <FaInstagram size={12} />
                    </button>
                    <button className="agents-social-btn" onClick={(e) => e.stopPropagation()}>
                      <FaTwitter size={12} />
                    </button>
                  </div> */}
                </div>
              </div>
            ))}
          </div>
          {/* Pagination */}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            siblingCount={1}
          />
        </div>
      </div>
      <Footer />
    </>
  );
}